<template>
<div id="LeaseContract">
  <div :class="`loader${loaderClass}`" v-show="loading"></div>
  <div id="page-content-wrapper" class="admin-content-area" >
    <template v-if="cantAccessPage === true">
      <div class="page-name">
        <div class="page-title">Lease Contracts</div>
        <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
      </div>
      <div class="container-fluid">
        <div class="admin-page-content contact-list">
          <data-table-filter-config :moduleName="'leaseContract'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
          <div class="data-table bg-white overflow-hidden">
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'leaseContract'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                  mode="remote"
                  ref="leaseContractReportTable"
                  title="Lease Contract"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
              </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="cantAccessPage === false">
      <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
      </div>
    </template>
    <template v-else>
      <loading-content></loading-content>
    </template>
    <app-footer></app-footer>
  </div>
</div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "LeaseContract",
  metaInfo(){
       return {
         title : 'Lease Contract Report | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action:'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Agr Type',
          field: 'contract_type',
          fpFieldType:"text",
          sortable: false,
          filterable: false,
      },
      {
          label: 'Agr Number',
          field: 'agreement_no',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Sched A Unit In Service Date',
          field: 'contract_start_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true,
      },
      {
          label: 'Sched A Unit Term Date',
          field: 'sched_term_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: false,
      },
      {
          label: 'Billing Freq',
          field: 'frequency',
          fpFieldType:"integer",
          filterable: true,
      },
      {
          label: "Customer Company Number",
          field: "company_code",
          filterable: true,
          fpFieldType:"option",
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "#company", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: "Customer Number",
          field: "customer_number",
          filterable: true,
          fpFieldType:"text",
          hidden:false,
      },
      {
          label: "Suffix",
          field: "customer_suffix",
          filterable: true,
          fpFieldType:"option",
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Customer Suffix", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Facility Code',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Facility Description',
          field: 'location_desc',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Contract Expiry Date',
          field: 'expiry_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true,
      },
      {
          label: 'Terms',
          field: 'contract_term',
          fpFieldType:"integer",
          hidden:false,
          // type:'number',
          filterable: true,
      },
      {
          label: 'Contract Equip Status',
          field: 'status',
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Contract Equipment Status", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [{text:'Pending',value:'pending'},{text:'Active',value:'active'},{text:'Closed',value:'closed'}], // dropdown (with selected values) instead of text input
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Contract Type',
          field: 'conType',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Equip Status',
          field: 'equipment_status',
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Make',
          field: 'manufacturer_code',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Make Descrip',
          field: 'manufacturer_desc',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Model',
          field: 'model',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Model Descrip',
          field: 'model_desc',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Equip Type Description',
          field: 'equip_type_desc',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Equip Type',
          field: 'equip_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: "Customer Name",
          field: "customer",
          filterable: true,
          fpFieldType:"text",
          hidden:false,
      },
      {
          label: 'Sales Per Cde',
          field: 'user_cde',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Sales Person',
          field: 'user',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Fixed Annual Revenue',
          field: 'fixed_rev',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'Variable Annual Revenue',
          field: 'variable_rev',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable: false,
      },
      {
          label: 'Total Annual Revenue',
          field: 'total_rev',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'FIXED01',
          field: 'fsection_rate1',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'FIXED02',
          field: 'fsection_rate2',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'FIXED03',
          field: 'fsection_rate3',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'VARIABLE01',
          field: 'vsection_rate1',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'VARIABLE02',
          field: 'vsection_rate2',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'VARIABLE03',
          field: 'vsection_rate3',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'EstVar01',
          field: 'estVar_rate1',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'EstVar02',
          field: 'estVar_rate2',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'EstVar03',
          field: 'estVar_rate3',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
      },
      {
          label: 'Customer Unit Number',
          field: 'cust_unit_no',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Equipment Year',
          field: 'year',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Serial Number',
          field: 'vin',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Substitute Unit Option',
          field: 'allow_substitute',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions:{
            filterDropdownItems: ['Yes','No']
          },

      },
      {
          label: 'Max Sub Days',
          field: 'max_sub_days',
          hidden:false,
          filterable: false,
          sortable:false,
          fpFieldType:"text",
      },
      {
          label: 'Max Sub Days Duration',
          field: 'max_sub_day_dur',
          hidden:false,
          filterable: false,
          sortable:false,
          fpFieldType:"text",
      },
      {
          label: 'User Returned',
          field: 'user_returned',
          hidden:false,
          filterable: true,
          sortable:false,
          fpFieldType:"text",
      },
      {
          label: 'Last Billed User',
          field: 'billed_user',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Date Last Billed',
          field: 'billed_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true,
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'lease_contract_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.leaseContractReportTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     self.action = "export";
    //     self.loadList();
    // },
    loadList: function(){
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/lease-contracts-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }

              self.action = "list";
              // self.loadList();

            } else {

              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'lease-contract-list')
        }
      });


    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/LeaseContractReport.vue